import {ElementType} from "react";
import {AtlassianIcon} from "./atlassian-crowd-icon";
import {BitBucketIcon} from "./bitbucket-icon";
import {EmailIcon} from "./email-icon";
import {GithubIcon} from "./github-icon";
import {GitlabIcon} from "./gitlab-icon";
import {GoogleIcon} from "./google-icon";
import {KeystoneIcon} from "./keystone-icon";
import {LdapIcon} from "./ldap-icon";
import {LinkedinIcon} from "./linkedin-icon";
import {MicrosoftIcon} from "./microsoft-icon";
import {OidcIcon} from "./oidc-icon";
import {SamlIcon} from "./saml-icon";

export const icons: { [key: string]: ElementType } = {
  atlassian: AtlassianIcon,
  bitBucket: BitBucketIcon,
  local: EmailIcon,
  github: GithubIcon,
  gitlab: GitlabIcon,
  google: GoogleIcon,
  keystone: KeystoneIcon,
  ldap: LdapIcon,
  linkedin: LinkedinIcon,
  microsoft: MicrosoftIcon,
  oidc: OidcIcon,
  saml: SamlIcon,
}
